import { FaUsers, FaUserFriends, FaThLarge, FaBuilding, FaMapMarkerAlt, FaSlidersH, FaStore, FaClipboardList } from "react-icons/fa";

// Iconos por item del menu (el backend/menu no trae icono). Se resuelve por el ultimo
// segmento del path (/seguridad/<x>) para que TODOS los items del sidebar tengan icono
// (necesario tambien cuando el sidebar esta colapsado y solo se ven iconos).
const ICONOS_RUTA_SIDEBAR = {
  usuarios: <FaUsers />,
  grupos: <FaUserFriends />,
  modulos: <FaThLarge />,
  companias: <FaBuilding />,
  sedes: <FaMapMarkerAlt />,
  parametros: <FaSlidersH />,
  sucursales: <FaStore />,
  auditoria: <FaClipboardList />,
};
export const iconoPorRutaSidebar = (path) =>
  ICONOS_RUTA_SIDEBAR[String(path || "").split("/").filter(Boolean).pop()?.toLowerCase()] || null;


// const routes = [
//   {
//     path: "/seguridad",
//     name: "Seguridad",
//     // icon: <BsShieldLockFill />,
//     subRoutes: [
//       {
//         path: "/seguridad/usuarios",
//         name: "Usuarios",
//       },
//       {
//         path: "/seguridad/grupos",
//         name: "Grupos",
//         // icon: <RiTeamFill />,
//         // subRoutes: [
//         //   {
//         //     path: "/seguridad/grupos/agregar",
//         //     name: "Agregar",
//         //     // icon: <RiTeamFill />,
//         //   },
//         //   {
//         //     path: "/seguridad/grupos",
//         //     name: "Listar",
//         //     // icon: <RiTeamFill />,
//         //   },
//         // ],
//       },
//       {
//         path: "/seguridad/modulos",
//         name: "Módulos",
//         // icon: <RxModulzLogo />,
//       },
//       {
//         path: "/seguridad/companias",
//         name: "Compañias",
//         // icon: <AiFillBank />,
//       },
//       {
//         path: "/seguridad/sedes",
//         name: "Sedes",
//         // icon: <MdOutlineLocationCity />,
//       },
//       {
//         path: "/seguridad/parametros",
//         name: "Parámetros",
//       },
//     ],
//   },
//   {
//     path: null,
//     name: "Salir",
//     // icon: <RiLogoutBoxLine />,
//   },
// ];
